import React, { memo, MouseEvent } from "react"
import { GiMicrophone } from "react-icons/gi"

import { Nickname } from "@shared/components"
import { Account, Schedule, Viewer } from "@shared/contexts"

import Icon from "./Icon"

interface Props {
  viewer: Viewer
  account: Account
  schedule: Schedule | null
  handleAction: Function
}

function User({ viewer, account, schedule, handleAction }: Props) {
  const isBlockedChat = viewer.isBlockedChat
  const isStreaming = schedule?.streamingUsername === viewer.username

  return (
    <div
      onClick={(e: MouseEvent) => {
        if (viewer.role === "ANONYMOUS") return
        handleAction({ viewer, account, schedule })
      }}
    >
      {isStreaming && <GiMicrophone role={viewer.role} />}
      <Icon
        role={viewer.role}
        isBlockedChat={isBlockedChat}
        device={viewer.device}
      />
      <Nickname
        role={viewer.role}
        nickname={viewer.nickname}
        isNicknameStyled={true}
        isViewer={true}
      />
    </div>
  )
}

export default memo(User)
